export * as textareaStyleConfigs from './style-configs';
export { Textarea } from './textarea';
export type { TextareaProps } from './types';
